import { I18n } from '../i18n';

const t = I18n.t;

export const isRequired = (value: unknown) => (value ? undefined : t('Error.required'));

export const isNumber = (value: string) =>
  value && !/^[+]?\d+([.]\d+)?$/i.test(value) ? t('Error.invalid_number') : undefined;

/**
 * Simple boolean email validation (returns true if valid, false otherwise). Use this for client-side form validation
 * without error messages.
 */
export const isValidEmail = (email: string): boolean => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

/** Email validation for redux-form. Returns undefined if valid, or an error message if invalid. */
export const emailValidationError = (value: string) =>
  value && !isValidEmail(value) ? t('Error.invalid_email') : undefined;
